import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-review-status-box',
  templateUrl: './review-status-box.component.html',
  styleUrls: ['./review-status-box.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, OverlayModule],
})
export class ReviewStatusBoxComponent {
  @Input() dateSubmitted: string;
  @Input() lastReviewed: string;
  @Input() reviewStatus: string;
  @Input() submissionDue: string;
  @Input() systemForced: boolean;

  public isOpen = false;
}
